(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-bespoke-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.closest('.qf-bsp-wrap');
  if (!root) root = document.querySelector('.qf-bsp-wrap');
  if (!root) return;

  /* ── Lightbox ─────────────── */
  var lightbox = root.querySelector('[data-qf-bsp-lightbox]');
  var grid = root.querySelector('[data-bsp-grid]');
  if (lightbox && grid) {
    var imgEl = lightbox.querySelector('.qf-bsp-lightbox__img');
    var capEl = lightbox.querySelector('.qf-bsp-lightbox__caption');
    var closeBtn = lightbox.querySelector('[data-qf-bsp-close]');
    var prevBtn = lightbox.querySelector('[data-qf-bsp-prev]');
    var nextBtn = lightbox.querySelector('[data-qf-bsp-next]');

    function visibleTriggers() {
      return Array.prototype.slice.call(
        grid.querySelectorAll('[data-qf-bsp-zoom]:not([hidden])')
      );
    }

    var current = 0;
    var lastFocus = null;

    function show(i) {
      var triggers = visibleTriggers();
      if (!triggers.length) return;
      if (i < 0) i = triggers.length - 1;
      if (i >= triggers.length) i = 0;
      current = i;
      var t = triggers[i];
      imgEl.src = t.getAttribute('data-src') || '';
      imgEl.alt = t.getAttribute('data-caption') || '';
      capEl.textContent = t.getAttribute('data-caption') || '';
      var multi = triggers.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
    }

    function open(trigger) {
      var triggers = visibleTriggers();
      var idx = triggers.indexOf(trigger);
      if (idx < 0) idx = 0;
      lastFocus = document.activeElement;
      show(idx);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('qf-bsp-lightbox-open');
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      closeBtn.focus();
    }

    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      setTimeout(function () { lightbox.hidden = true; }, 250);
      document.body.classList.remove('qf-bsp-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    grid.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-qf-bsp-zoom]');
      if (!trigger || trigger.hidden) return;
      e.preventDefault();
      open(trigger);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(current - 1); });
    nextBtn.addEventListener('click', function () { show(current + 1); });

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
    });

    var touchStartX = null;
    lightbox.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
    }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = (e.changedTouches[0].clientX) - touchStartX;
      if (Math.abs(dx) > 50) {
        if (dx < 0) show(current + 1);
        else show(current - 1);
      }
      touchStartX = null;
    });
  }

  /* ── Filter logic ─────────────── */
  var checkboxes = root.querySelectorAll('[data-bsp-filter]');
  var clearBtn = root.querySelector('[data-bsp-clear]');
  var emptyMsg = root.querySelector('[data-bsp-empty]');
  if (!grid || checkboxes.length === 0) return;

  function applyFilters() {
    var active = {};
    checkboxes.forEach(function (cb) {
      if (!cb.checked) return;
      var group = cb.dataset.group;
      if (!active[group]) active[group] = [];
      active[group].push(cb.dataset.value);
    });

    var anyActive = Object.keys(active).length > 0;
    if (clearBtn) clearBtn.hidden = !anyActive;

    var tiles = grid.querySelectorAll('[data-bsp-product]');
    var visibleCount = 0;
    tiles.forEach(function (tile) {
      var tagsStr = tile.getAttribute('data-tags') || '';
      var tags = tagsStr.split(',').map(function (t) { return t.trim(); });
      var matches = Object.keys(active).every(function (group) {
        var wanted = active[group];
        return wanted.some(function (v) { return tags.indexOf(v) !== -1; });
      });
      tile.hidden = !matches;
      if (matches) visibleCount++;
    });

    if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
  }

  checkboxes.forEach(function (cb) {
    cb.addEventListener('change', applyFilters);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      checkboxes.forEach(function (cb) { cb.checked = false; });
      applyFilters();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-bespoke-room"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.bsr-wrap').forEach(function (root) {
      var form = root.querySelector('.bsr-form__form');
      if (!form) return;
      var select = form.querySelector('select[name="project"]');
      var errorEl = form.querySelector('.bsr-form__error');
      var thanks = root.querySelector('.bsr-form__thanks');
      var formSection = root.querySelector('#bsr-form');

      function scrollToForm() {
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      root.querySelectorAll('.bsr-gallery-wrap').forEach(function (wrap) {
        var g = wrap.querySelector('.bsr-gallery');
        if (!g) return;
        var prev = wrap.querySelector('.bsr-gallery__nav--prev');
        var next = wrap.querySelector('.bsr-gallery__nav--next');
        var cur = wrap.querySelector('.bsr-gallery__cur');
        function step(dir) {
          g.scrollBy({ left: dir * g.clientWidth, behavior: 'smooth' });
        }
        if (prev)
          prev.addEventListener('click', function () {
            step(-1);
          });
        if (next)
          next.addEventListener('click', function () {
            step(1);
          });
        if (cur) {
          g.addEventListener('scroll', function () {
            cur.textContent = Math.round(g.scrollLeft / g.clientWidth) + 1;
          });
        }
      });

      root.querySelectorAll('[data-scroll-form]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToForm();
        });
      });

      root.querySelectorAll('.bsr-project__enquire').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var title = btn.getAttribute('data-project');
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === title) {
              select.selectedIndex = i;
              break;
            }
          }
          scrollToForm();
        });
      });

      function showError(msg) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
      function clearError() {
        errorEl.hidden = true;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        var company = form.getAttribute('data-klaviyo-company');
        var listId = form.getAttribute('data-klaviyo-list');
        if (!company || !listId) {
          showError('Form not configured yet. Please try again later.');
          return;
        }
        var selectedOpt = select.options[select.selectedIndex];
        var data = {
          email: form.email.value.trim(),
          name: form.name.value.trim(),
          phone: form.phone.value.trim(),
          postcode: form.postcode.value.trim(),
          room: form.getAttribute('data-room'),
          project: select.value,
          projectUrl: selectedOpt
            ? selectedOpt.getAttribute('data-url') || form.getAttribute('data-page-url')
            : form.getAttribute('data-page-url'),
        };
        var btn = form.querySelector('.bsr-form__btn');
        btn.disabled = true;
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Bespoke ' + data.room,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: data.email,
                    first_name: data.name,
                    phone_number: data.phone,
                    properties: {
                      postcode: data.postcode,
                      bespoke_room: data.room,
                      bespoke_project: data.project,
                      bespoke_project_url: data.projectUrl,
                    },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        };
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
          body: JSON.stringify(payload),
        })
          .then(function (res) {
            if (!res.ok && res.status !== 202) throw new Error('Klaviyo ' + res.status);
            window.dispatchEvent(
              new CustomEvent('bespokeQuoteSubmitted', {
                detail: {
                  room: data.room,
                  project: data.project,
                  project_url: data.projectUrl,
                },
              })
            );
            var thankYouUrl = form.getAttribute('data-thankyou-url');
            if (thankYouUrl) {
              window.location.href = thankYouUrl;
              return;
            }
            form.hidden = true;
            thanks.hidden = false;
            thanks.scrollIntoView({ behavior: 'smooth', block: 'start' });
          })
          .catch(function () {
            btn.disabled = false;
            showError('Something went wrong — please try again.');
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-first-bespoke-joinery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.qf-bj-tech').forEach(function (tech) {
  var track = tech.querySelector('.qf-bj-tech__track');
  if (!track) return;
  var prev = tech.querySelector('.qf-bj-nav__btn--prev');
  var next = tech.querySelector('.qf-bj-nav__btn--next');

  function step() {
    var card = track.querySelector('.qf-bj-card');
    if (!card) return 320;
    var styles = window.getComputedStyle(track);
    var gap = parseInt(styles.columnGap || styles.gap || '24', 10) || 24;
    return card.getBoundingClientRect().width + gap;
  }

  if (prev) {
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
  }
  if (next) {
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-first-bespoke"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.currentScript && document.currentScript.closest('.qf-bsp-wrap');
  // Fallback: query the most recently rendered wrap (sections on Shopify usually have one per page).
  if (!root) root = document.querySelector('.qf-bsp-wrap');
  if (!root) return;

  var lightbox = root.querySelector('[data-qf-bsp-lightbox]');
  if (!lightbox) return;

  var imgEl = lightbox.querySelector('.qf-bsp-lightbox__img');
  var capEl = lightbox.querySelector('.qf-bsp-lightbox__caption');
  var closeBtn = lightbox.querySelector('[data-qf-bsp-close]');
  var prevBtn = lightbox.querySelector('[data-qf-bsp-prev]');
  var nextBtn = lightbox.querySelector('[data-qf-bsp-next]');

  var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-qf-bsp-zoom]'));
  if (!triggers.length) return;

  var current = 0;
  var lastFocus = null;

  function show(i) {
    if (i < 0) i = triggers.length - 1;
    if (i >= triggers.length) i = 0;
    current = i;
    var t = triggers[i];
    imgEl.src = t.getAttribute('data-src') || '';
    imgEl.alt = t.getAttribute('data-caption') || '';
    capEl.textContent = t.getAttribute('data-caption') || '';
    var multi = triggers.length > 1;
    prevBtn.hidden = !multi;
    nextBtn.hidden = !multi;
  }

  function open(i) {
    lastFocus = document.activeElement;
    show(i);
    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qf-bsp-lightbox-open');
    requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
    closeBtn.focus();
  }

  function close() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    setTimeout(function () { lightbox.hidden = true; }, 250);
    document.body.classList.remove('qf-bsp-lightbox-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  triggers.forEach(function (t, i) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      open(i);
    });
  });

  closeBtn.addEventListener('click', close);
  prevBtn.addEventListener('click', function () { show(current - 1); });
  nextBtn.addEventListener('click', function () { show(current + 1); });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) close();
  });

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });

  // Touch swipe (mobile)
  var touchStartX = null;
  lightbox.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) touchStartX = e.touches[0].clientX;
  }, { passive: true });
  lightbox.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    var dx = (e.changedTouches[0].clientX) - touchStartX;
    if (Math.abs(dx) > 50) {
      if (dx < 0) show(current + 1);
      else show(current - 1);
    }
    touchStartX = null;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-first-smart-hardware"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.qf-sh-mech').forEach(function (mech) {
  var track = mech.querySelector('.qf-sh-mech__track');
  if (!track) return;
  var prev = mech.querySelector('.qf-sh-nav__btn--prev');
  var next = mech.querySelector('.qf-sh-nav__btn--next');

  function step() {
    var card = track.querySelector('.qf-sh-card');
    if (!card) return 320;
    var styles = window.getComputedStyle(track);
    var gap = parseInt(styles.columnGap || styles.gap || '24', 10) || 24;
    return card.getBoundingClientRect().width + gap;
  }

  if (prev) {
    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
  }
  if (next) {
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
